"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.separateThousands = void 0;
// https://stackoverflow.com/a/2901298/9843487
exports.separateThousands = (s) => String(s).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
